module.exports = __webpack_public_path__ + "static/media/Errormark.b9545e09.svg";